import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { pageContext } from 'ctm-util-functions';

const DisclaimerMessage = styled.div`
    font-size: 1.5rem;
    line-height: 2rem;
    margin-top: ${(props) => (props.isXs ? '1.2rem' : '0.6rem')};
`;

const DisclaimerMessageExtended = styled.div`
    font-size: 1.5rem;
    line-height: 2rem;
`;

const GstMessage = (props) => {
    const { showFeaturesDisclaimer } = props;
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';

    return (
        <DisclaimerMessage isXs={isXs}>
            Prices quoted may change based on factors like rounding and further questions asked by the insurer. Results are inclusive of GST & Govt. charges.
            { showFeaturesDisclaimer
            && (
                <DisclaimerMessageExtended>
                    <p>
                        <strong>
                            The information on this page is subject to exclusions, restrictions, and sub-limits. Please refer to the PDS for details.
                        </strong>
                    </p>
                </DisclaimerMessageExtended>
            )}
        </DisclaimerMessage>
    );
};

GstMessage.propTypes = {
    showFeaturesDisclaimer: PropTypes.bool
};

export default GstMessage;
